import clsx from 'clsx';
import { MouseEvent, RefObject, forwardRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ListItemIcon, ListItemText, MenuItem } from 'netline-ui';
import { ProductsMenuItem as ProductsMenuItemType } from 'types';
import UrlIcon from 'view/components/UrlIcon/UrlIcon';

type MenuItemClickHandler = (product: ProductsMenuItemType, event: MouseEvent<HTMLAnchorElement>) => void;

type ProductsMenuItemProps = {
  className?: string;
  product: ProductsMenuItemType;
  onMenuItemClick?: MenuItemClickHandler;
};

const ProductsMenuItem = forwardRef(
  ({ className, product, onMenuItemClick }: ProductsMenuItemProps, ref: RefObject<HTMLAnchorElement>) => {
    const {
      t,
      i18n: { exists },
    } = useTranslation();

    const { id, text, url, target, available, icon, iconAltText, ...props } = product;

    const handleMenuItemClick = useCallback(
      (event) => {
        onMenuItemClick?.(product, event);
      },
      [onMenuItemClick, product],
    );

    return (
      <a
        onClick={handleMenuItemClick}
        href={url}
        target={target}
        ref={ref}
        data-testid="ProductsMenuItem-root"
        {...props}
        className={clsx(className)}
      >
        <MenuItem>
          {icon && (
            <ListItemIcon>
              <UrlIcon nameOrUrl={icon} alt={iconAltText ?? text} />
            </ListItemIcon>
          )}
          <ListItemText>{exists(text) ? t(text) : text}</ListItemText>
        </MenuItem>
      </a>
    );
  },
);

export default ProductsMenuItem;
